module.exports = " <i class=icon :class=classNames :style=\"{'font-size': size + 'px'}\"><slot></slot></i> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/icon/icon.vue
 ** module id = 448
 ** module chunks = 1
 **/